import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Button } from "../components/ui/button";
import { NETWORK_STEPS, NETWORK_COMPLIANCE } from "../lib/data";

const Icon = ({ name, className }) => { const C = Icons[name] || Icons.Circle; return <C className={className} />; };
const fadeUp = { hidden: { opacity: 0, y: 24 }, show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.45, delay: i * 0.05 } }) };

const SHOP_STEPS = [
  { icon: "Search", t: "Browse Genesis Mall", d: "Discover businesses, services and products across the ecosystem." },
  { icon: "ShoppingCart", t: "Choose & Connect", d: "Pick what you need and connect with the right Genesis business." },
  { icon: "PackageCheck", t: "Get Served", d: "Receive your product or service with a trusted experience." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="bg-cream-100 text-soil-700 pt-24 pb-24">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 pb-10 text-center">
        <div className="max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-terracotta-600 mb-3">How It Works</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-forest-800">One Group. <span className="saffron-text">Many Opportunities.</span></h1>
          <p className="mt-4 text-lg text-soil-600">Whether you're here to shop or to build a business — here's how Genesis works.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-6">
        <div className="text-center mb-8"><div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta-600 mb-3">Shopping</div><h2 className="font-heading text-2xl sm:text-3xl font-bold text-forest-800">Explore Genesis Mall</h2></div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {SHOP_STEPS.map((s, i) => (
            <motion.div key={s.t} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp} className="card-cream rounded-2xl p-6">
              <div className="w-10 h-10 rounded-xl bg-terracotta-100 flex items-center justify-center mb-3"><Icon name={s.icon} className="w-5 h-5 text-terracotta-600" /></div>
              <div className="font-heading text-lg font-bold text-forest-800">{s.t}</div>
              <div className="text-soil-500 text-sm mt-1">{s.d}</div>
            </motion.div>
          ))}
        </div>
        <div className="mt-6 text-center"><Link to="/mall" data-testid="how-mall-cta"><Button className="forest-gradient text-cream-50 font-bold h-11 px-6 rounded-full">Explore Genesis Mall</Button></Link></div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-8"><div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta-600 mb-3">Affiliate</div><h2 className="font-heading text-2xl sm:text-3xl font-bold text-forest-800">Build With the Genesis Network</h2></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {NETWORK_STEPS.map((s, i) => (
            <motion.div key={s.t} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp} className="card-cream rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl forest-gradient flex items-center justify-center"><Icon name={s.icon} className="w-5 h-5 text-cream-50" /></div>
                <span className="font-mono-fin text-terracotta-500 font-bold">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <div className="font-heading text-lg font-bold text-forest-800">{s.t}</div>
              <div className="text-soil-500 text-sm mt-1">{s.d}</div>
            </motion.div>
          ))}
        </div>
        <p className="text-soil-500 text-xs mt-8 max-w-3xl" data-testid="how-compliance">{NETWORK_COMPLIANCE}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/register" data-testid="how-register-cta"><Button className="terracotta-gradient text-cream-50 font-bold h-11 px-6 rounded-full">Join Genesis Network</Button></Link>
          <Link to="/ranks-rewards" data-testid="how-ranks-cta"><Button variant="outline" className="border-forest-500/40 text-forest-700 hover:bg-forest-100 h-11 px-6 rounded-full">Ranks &amp; Rewards</Button></Link>
        </div>
      </section>
    </div>
  );
}
